/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
import { fetchUser, userLogout } from 'actions';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Navigation, Routes } from 'templates';
import { useUser } from '@clerk/clerk-react';
import Unauthorized from 'components/Unauthorized';
import { GlobalStyle } from './ui/yousty';

const UIWrapper = () => {
  const fetchingUser = useSelector(state => state.userState.fetching);
  const { pathname } = useLocation();

  if (fetchingUser && pathname !== '/' && !pathname.startsWith('/auth')) {
    return <></>;
  }

  return (
    <>
      <Navigation />
      <Routes />
      <Modal />
    </>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const { isSignedIn } = useUser();
  const notAuthorized = useSelector(state => state.userState.notAuthorized);
  const userFetched = useSelector(state => state.userState.fetched);
  const { pathname } = useLocation();

  if (pathname !== '/') {
    if (isSignedIn && notAuthorized) {
      return (
        <>
          <GlobalStyle />
          <Unauthorized />
          <Modal />
        </>
      );
    }

    if (isSignedIn) {
      if (!userFetched) {
        dispatch(fetchUser());
      }
    } else {
      dispatch(userLogout());
    }
  }

  return (
    <>
      <Helmet>
        <title>Berufsorientierung in der Schule - Berufswahl-Radar von Yousty</title>
        <meta
          name="description"
          content="Als Lehrer die Schulklasse bei der Berufswahl optimal begleiten. Helfen Sie Ihren Schüler/innen, die passende Schnupperlehre und Lehrstelle zu finden."
        />
        <meta
          name="keywords"
          content="Berufswahl, Berufswahl-Radar, Berufswahl, Schnupperlehren, Bewerbungsphase, Vorstellungsgespräch, Berufsmessen, Lehrstellen"
        />
      </Helmet>
      <GlobalStyle />
      <UIWrapper />
    </>
  );
};

export default App;
